import React, { useState } from "react";
import narrative_image from "../../../../../../assets/new_id.png";
import semiFilled from "../../../../../../assets/hero_filled.png";
import dependableImg from "../../../../../../assets/dependable.png";
import complianceImg from "../../../../../../assets/compliance.png";
import sociabilityImg from "../../../../../../assets/sociability.png";
import independenceImg from "../../../../../../assets/independence.png";
import growthImg from "../../../../../../assets/growth.png";
import teamsIcon from "../../../../../../assets/teams.png";
import emailIcon from "../../../../../../assets/email.png";
import meetingsIcon from "../../../../../../assets/meets.png";
import townhallIcon from "../../../../../../assets/townhall.png";
import linkedinIcon from "../../../../../../assets/linkedIn.png";
import RecommendedPositionCard from "./RecommendedPositionCard";


const allChannels = [
  { id: "email", label: "Email", icon: emailIcon },
  { id: "teams", label: "Teams", icon: teamsIcon },
  { id: "townhall", label: "Townhall", icon: townhallIcon },
  { id: "linkedin", label: "LinkedIn", icon: linkedinIcon },
  { id: "meetings", label: "Meetings", icon: meetingsIcon },
];


const TIMELINE_OPTIONS = ["Short-term", "Medium-Term", "Long-Term"];
const FREQUENCY_OPTIONS = ["Daily", "Weekly", "Monthly", "Quarterly"];


export default function BuildNarrativeForm({
  selectedCard,
  selectedChannels = [],
  otherChannel = "",
  questionA,
  setQuestionA,
  questionB,
  setQuestionB,
  tasks,
  setTasks,
  currentChannelId,
  setCurrentChannelId,
  selectedLevel,
  onNextStep = () => {},
  isSaving = false,
}) {
  const cardImgMap = {
    "Mr/Ms. Dependable": dependableImg,
    "Compliance Champion": complianceImg,
    Sociability: sociabilityImg,
    "Independence & Advocacy": independenceImg,
    "Growth & Innovation": growthImg,
  };


  let card = selectedCard;
  if (selectedCard) {
    const overrideImg =
      selectedCard.img || cardImgMap[selectedCard.name] || dependableImg;
    card = { ...selectedCard, img: overrideImg };
  } else {
    card = {
      header: "RECOMMENDED POSITIONING",
      name: "Mr/Ms. Dummy",
      tagline: "Build trust through steady presence and risk reduction.",
      bullets: [
        "Maintain a steady, reliable presence",
        "Focus on risk reduction strategies",
        "Emphasize problem avoidance",
        "Provide clear, consistent communication",
      ],
      img: dependableImg,
      alt: "Dependable Icon",
    };
  }


  // map only selected channels for the button bar
  const selectedChannelObjs = (selectedChannels || [])
    .map((id) => {
      if (id === "others") {
        return {
          id: "others",
          label:
            otherChannel && otherChannel.trim() !== "" ? otherChannel : "Others",
          icon: null,
        };
      }
      return allChannels.find((ch) => ch.id === id);
    })
    .filter(Boolean);


  // highlight state for button bar
  const [selectedChannel, setSelectedChannel] = useState(
    currentChannelId || selectedChannels[0] || ""
  );
  const [showTimeline, setShowTimeline] = useState(Array(4).fill(false));
  const [showFrequency, setShowFrequency] = useState(Array(4).fill(false));


  const handleTaskChange = (idx, val) => {
    setTasks((prev) => prev.map((t, i) => (i === idx ? { ...t, value: val } : t)));
  };


  const handleTimelineChange = (idx, val) => {
    setTasks((prev) =>
      prev.map((t, i) => (i === idx ? { ...t, timeline: val } : t))
    );
    setShowTimeline((show) =>
      show.map((open, i) => (i === idx ? false : open))
    );
  };


  const handleFrequencyChange = (idx, val) => {
    setTasks((prev) =>
      prev.map((t, i) => (i === idx ? { ...t, frequency: val } : t))
    );
    setShowFrequency((show) =>
      show.map((open, i) => (i === idx ? false : open))
    );
  };


  return (
    <div className="w-full bg-white max-h-[80vh] overflow-y-auto scrollbar-hide flex flex-col">
      <div className="max-w-6xl w-full pb-4">
        <div
          className="text-[#323232] text-[16px] font-normal leading-[160%] mb-2"
          style={{ fontFamily: "Gotham, sans-serif" }}
        >
          Now that you know what they seek, let's create your brand.
         
        </div>
      </div>
      <div className=" w-full flex flex-row gap-4 px-8">
        {/* LEFT: hero image + progress text */}
        <div className="flex flex-col items-center min-w-[320px] max-w-[367px] pt-6">
          <div
            className="relative"
            style={{
              width: 268.56,
              height: 313.44,
              marginTop: 0,
              marginLeft: 8,
              borderRadius: 10,
            }}
          >
            <img
              src={narrative_image}
              alt="Narrative Hero"
              className="block w-full h-full object-contain"
              style={{ borderRadius: 10 }}
              draggable={false}
            />
            <img
              src={semiFilled}
              alt="Narrative progress"
              className="pointer-events-none select-none"
              style={{
                position: "absolute",
                left: 0,
                top: 42,
                width: "100%",
                height: "100%",
                objectFit: "contain",
                borderRadius: 10,
              }}
              draggable={false}
            />
            {/* Progress overlay */}
            <div
              className="absolute"
              style={{
                left: -24,
                bottom: 24,
                minWidth: 0,
                textAlign: "left",
              }}
            >
              <div className="flex flex-col">
                <span
                  style={{
                    fontFamily: "Gotham, sans-serif",
                    fontWeight: 500,
                    fontStyle: "normal",
                    fontSize: 11.94,
                    lineHeight: "135%",
                    letterSpacing: 0,
                    textTransform: "uppercase",
                    color: "#454545",
                  }}
                >
                  MY NARRATIVE
                </span>
                <span
                  style={{
                    fontFamily: "Gotham, sans-serif",
                    fontWeight: 500,
                    fontStyle: "normal",
                    fontSize: 15.92,
                    lineHeight: "135%",
                    letterSpacing: 0,
                    textTransform: "uppercase",
                    color: "#1DA4A2",
                  }}
                >
                  70% COMPLETE
                </span>
              </div>
              <div
                style={{
                  width: 199.8,
                  borderTop: "1px solid #454545",
                  marginTop: 4,
                }}
              />
            </div>
          </div>


          {/* Card below the image */}
          <RecommendedPositionCard card={card} />
        </div>


        <div className="flex-1 flex flex-col pt-6 pl-10 ">
          {/* Section A */}
          <div className="flex flex-row items-start mb-10">
            <div
              className="flex items-center justify-center mr-4 mt-2"
              style={{
                width: 39.73,
                height: 39.73,
                borderRadius: 66.22,
                background: "#E6E6E6",
                border: "1.66px solid #CCCCCC",
              }}
            >
              <span
                style={{
                  color: "#444444",
                  fontFamily: "Gotham, sans-serif",
                  fontWeight: 400,
                  fontSize: 22.88,
                  lineHeight: "100%",
                  letterSpacing: 0,
                }}
              >
                A
              </span>
            </div>
            <div className="flex-1">
              <div
                className="font-bold text-[#222] text-lg mb-0"
                style={{ fontFamily: "Gotham, sans-serif" }}
              >
                Who Am I to my Stakeholders?
              </div>
              <div
                className="text-[#949494] text-base mb-2"
                style={{ fontFamily: "Gotham, sans-serif" }}
              >
                Eg. I am the Operations Lead who ensures we never miss a deadline, irrespective of project complexity.
              </div>
              <textarea
                rows={4}
                className="block w-full max-w-[653.74px] h-[166.08px] rounded-md border border-[#ADADAD] text-[#222] text-base p-3 focus:outline-none focus:border-[#13AAA4]"
                style={{ fontFamily: "Gotham, sans-serif" }}
                value={questionA}
                onChange={(e) => setQuestionA(e.target.value)}
              />
            </div>
          </div>


          {/* Section B */}
          <div className="flex flex-row items-start mb-10">
            <div
              className="flex items-center justify-center mr-4 mt-2"
              style={{
                width: 39.73,
                height: 39.73,
                borderRadius: 66.22,
                background: "#E6E6E6",
                border: "1.66px solid #CCCCCC",
              }}
            >
              <span
                style={{
                  color: "#444444",
                  fontFamily: "Gotham, sans-serif",
                  fontWeight: 400,
                  fontSize: 22.88,
                  lineHeight: "100%",
                  letterSpacing: 0,
                }}
              >
                B
              </span>
            </div>
            <div className="flex-1">
              <div
                className="font-bold text-[#222] text-lg mb-0"
                style={{ fontFamily: "Gotham, sans-serif" }}
              >
                What situations can be{" "}
                <span className="text-[#13AAA4] font-bold">{card.name}</span> in?
              </div>
              <div
                className="text-[#949494] text-base mb-2"
                style={{ fontFamily: "Gotham, sans-serif" }}
              >
                When last-minute data, feedback, or crisis hits and everyone is scrambling.
              </div>
              <textarea
                rows={3}
                className="block w-full max-w-[653.74px] h-[140.47px] rounded-md border border-[#ADADAD] text-[#222] text-base p-3 focus:outline-none focus:border-[#13AAA4]"
                style={{ fontFamily: "Gotham, sans-serif" }}
                value={questionB}
                onChange={(e) => setQuestionB(e.target.value)}
              />
            </div>
          </div>


          {/* Section C - FIXED */}
          <div className="my-12">
            <div className="flex items-center mb-2">
              <div
                className="flex items-center justify-center mr-4"
                style={{
                  width: 39.73,
                  height: 39.73,
                  borderRadius: '50%',
                  background: "#E6E6E6",
                  border: "1.66px solid #CCCCCC",
                }}
              >
                <span
                  style={{
                    color: "#444444",
                    fontFamily: "Gotham, sans-serif",
                    fontWeight: 400,
                    fontSize: 22.88,
                    lineHeight: "100%",
                    letterSpacing: 0,
                  }}
                >
                  C
                </span>
              </div>
              <div>
                <span
                  style={{
                    fontFamily: "Gotham, sans-serif",
                    fontWeight: 700,
                    fontSize: "18px",
                    lineHeight: "165%",
                    color: "#323232",
                  }}
                >
                  3 Things I will do to become{" "}
                  <span className="text-[#13AAA4] font-bold">{card.name}</span>
                </span>
                <div
                  style={{
                    fontFamily: "Gotham, sans-serif",
                    fontWeight: 325,
                    fontSize: "15px",
                    lineHeight: "165%",
                    color: "#888888",
                  }}
                >
                  Eg. For Email/Slack channels: Send proactive status updates before they are asked for.
                </div>
              </div>
            </div>


            {/* Button Bar - FIXED */}
            <div
              className="flex flex-row ml-12 items-center"
              style={{
                width: "666px",
                height: "44px",
                background: "#E6E6E680",
                borderRadius: "4px",
                padding: "8px",
                gap: "8px",
                marginBottom: "24px",
              }}
            >
              {selectedChannelObjs.map((ch) => (
                <button
                  key={ch.id}
                  className="flex items-center justify-center"
                  style={{
                    height: "28px",
                    minWidth: "104px",
                    borderRadius: "4px",
                    background: selectedChannel === ch.id ? "#FFFFFF" : "transparent",
                    boxShadow: selectedChannel === ch.id ? "0px 2px 4px rgba(0,0,0,0.1)" : "none",
                    fontFamily: "Gotham, sans-serif",
                    fontSize: "12px",
                    fontWeight: 325,
                    lineHeight: "160%",
                    color: "#000000",
                    paddingLeft: "12px",
                    paddingRight: "12px",
                    border: "none",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setSelectedChannel(ch.id);
                    if (setCurrentChannelId) setCurrentChannelId(ch.id);
                  }}
                >
                  {ch.icon ? (
                    <img
                      src={ch.icon}
                      alt={ch.label}
                      style={{ width: 16, height: 16, marginRight: 6 }}
                    />
                  ) : (
                    <span style={{ fontSize: "18px", fontWeight: 700, marginRight: 4 }}>
                      +
                    </span>
                  )}
                  <span>{ch.label}</span>
                </button>
              ))}
            </div>


            {/* Input Tasks - FIXED with proper sizing */}
              <div>
                {tasks.map((task, idx) => (
                  <div
                    key={idx}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginLeft: 48,
                      marginBottom: 16,
                      width: "100%",
                      maxWidth: 700,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        borderBottom: "1.5px solid #222",
                        height: 42,
                        flex: 1,
                        maxWidth: "395px",
                        marginRight: 12,
                      }}
                    >
                      <span
                        style={{
                          fontFamily: "Gotham, sans-serif",
                          color: "#222",
                          fontSize: "14px",
                          fontWeight: 325,
                          marginRight: 8,
                          display: "inline-block",
                        }}
                      >
                        {idx + 1}.
                      </span>
                      <input
                        className="focus:outline-none"
                        style={{
                          minWidth: 100,
                          background: "transparent",
                          height: 42,
                          fontFamily: "Gotham, sans-serif",
                          fontWeight: 400,
                          fontSize: "16px",
                          lineHeight: "160%",
                          border: "none",
                          outline: "none",
                          boxShadow: "none",
                          color: task.value ? "#222" : "#A4A4A4",
                          flex: 1,
                        }}
                        placeholder={`Action Task ${idx + 1}`}
                        value={task.value}
                        onChange={(e) => handleTaskChange(idx, e.target.value)}
                      />
                    </div>
                    <div
                      style={{ position: "relative", width: 124, height: 34, marginRight: 10 }}
                    >
                      <button
                        type="button"
                        style={{
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          paddingLeft: "12px",
                          paddingRight: "12px",
                          borderRadius: "3.04px",
                          border: "1px solid #F0F0F0",
                          background: "#FFFFFF",
                          fontFamily: "Gotham, sans-serif",
                          fontSize: "12px",
                          fontWeight: 300,
                          lineHeight: "230%",
                          color: "#585858",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          setShowTimeline((show) =>
                            show.map((open, i) => (i === idx ? !open : false))
                          )
                        }
                      >
                        {task.timeline || "Timeline"}
                        <svg
                          width="8"
                          height="4"
                          viewBox="0 0 14 8"
                          fill="none"
                          style={{ marginLeft: 6, marginRight: -6 }}
                        >
                          <path
                            d="M1 1.5L7 7.5L13 1.5"
                            stroke="#C1C1C1"
                            strokeWidth="1.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                      {showTimeline[idx] && (
                        <div
                          className="absolute z-10 w-full top-full left-0 bg-white border border-[#ADADAD] rounded"
                          style={{
                            fontFamily: "Gotham, sans-serif",
                            fontSize: 12,
                            marginTop: 3,
                          }}
                        >
                          {TIMELINE_OPTIONS.map((opt) => (
                            <div
                              key={opt}
                              className="px-3 py-2 cursor-pointer hover:bg-[#E6E6E6]"
                              style={{ borderRadius: 2.2, color: "#222" }}
                              onClick={() => handleTimelineChange(idx, opt)}
                            >
                              {opt}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    <div style={{ position: "relative", width: 124, height: 34 }}>
                      <button
                        type="button"
                        style={{
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          paddingLeft: "12px",
                          paddingRight: "12px",
                          borderRadius: "3.04px",
                          border: "1px solid #F0F0F0",
                          background: "#FFFFFF",
                          fontFamily: "Gotham, sans-serif",
                          fontSize: "12px",
                          fontWeight: 300,
                          lineHeight: "230%",
                          color: "#585858",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          setShowFrequency((show) =>
                            show.map((open, i) => (i === idx ? !open : false))
                          )
                        }
                      >
                        {task.frequency || "Frequency"}
                        <svg
                          width="8"
                          height="4"
                          viewBox="0 0 14 8"
                          fill="none"
                          style={{ marginLeft: 6, marginRight: -6 }}
                        >
                          <path
                            d="M1 1.5L7 7.5L13 1.5"
                            stroke="#C1C1C1"
                            strokeWidth="1.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                      {showFrequency[idx] && (
                        <div
                          className="absolute z-10 w-full top-full left-0 bg-white border border-[#ADADAD] rounded"
                          style={{
                            fontFamily: "Gotham, sans-serif",
                            fontSize: 12,
                            marginTop: 3,
                            color: "#585858",
                          }}
                        >
                          {FREQUENCY_OPTIONS.map((opt) => (
                            <div
                              key={opt}
                              className="px-3 py-2 cursor-pointer hover:bg-[#E6E6E6]"
                              style={{ borderRadius: 2.2, color: "#222" }}
                              onClick={() => handleFrequencyChange(idx, opt)}
                            >
                              {opt}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>


            <div className="mt-12 flex">
              <button
                className="bg-black text-white text-lg font-medium rounded-[16.2px] ml-12 px-8 py-4 flex items-center"
                style={{
                  width: 231,
                  height: 56,
                  justifyContent: "space-between",
                  fontFamily: "Gotham, sans-serif",
                  paddingTop: 17.8,
                  paddingBottom: 17.8,
                  paddingLeft: 16.2,
                  paddingRight: 16.2,
                  borderRadius: 16.2,
                }}
                onClick={() => onNextStep()}
              >
                Go to Next Step
                <span
                  className="ml-2"
                  style={{ display: "flex", alignItems: "center", fontSize: 20 }}
                >
                  <svg width={22} height={22} viewBox="0 0 22 22" fill="none">
                    <circle cx="11" cy="11" r="11" fill="#fff" />
                    <path
                      d="M9 7l4 4-4 4"
                      stroke="#151A1F"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


// import React, { useState } from "react";
// import narrative_image from "../../../../../../assets/new_id.png";
// import semiFilled from "../../../../../../assets/hero_filled.png";
// import dependableImg from "../../../../../../assets/dependable.png";
// import complianceImg from "../../../../../../assets/compliance.png";
// import sociabilityImg from "../../../../../../assets/sociability.png";
// import independenceImg from "../../../../../../assets/independence.png";
// import growthImg from "../../../../../../assets/growth.png";
// import teamsIcon from "../../../../../../assets/teams.png";
// import emailIcon from "../../../../../../assets/email.png";
// import meetingsIcon from "../../../../../../assets/meets.png";
// import townhallIcon from "../../../../../../assets/townhall.png";
// import linkedinIcon from "../../../../../../assets/linkedIn.png";
// import RecommendedPositionCard from "./RecommendedPositionCard";

// const allChannels = [
//   { id: "email", label: "Email", icon: emailIcon },
//   { id: "teams", label: "Teams", icon: teamsIcon },
//   { id: "townhall", label: "Townhall", icon: townhallIcon },
//   { id: "linkedin", label: "LinkedIn", icon: linkedinIcon },
//   { id: "meetings", label: "Meetings", icon: meetingsIcon },
// ];

// const TIMELINE_OPTIONS = ["Short-term", "Medium-Term", "Long-Term"];
// const FREQUENCY_OPTIONS = ["Daily", "Weekly", "Monthly", "Quarterly"];

// export default function BuildNarrativeForm({
//   selectedCard,
//   selectedChannels = [],
//   otherChannel = "",
//   questionA,
//   setQuestionA,
//   questionB,
//   setQuestionB,
//   tasks,
//   setTasks,
//   currentChannelId,
//   setCurrentChannelId,
//   selectedLevel,
//   onNextStep = () => {},
//   isSaving = false,
// }) {
//   const cardImgMap = {
//     "Mr/Ms. Dependable": dependableImg,
//     "Compliance Champion": complianceImg,
//     Sociability: sociabilityImg,
//     "Independence & Advocacy": independenceImg,
//     "Growth & Innovation": growthImg,
//   };

//   let card = selectedCard;
//   if (selectedCard) {
//     const overrideImg =
//       selectedCard.img || cardImgMap[selectedCard.name] || dependableImg;
//     card = { ...selectedCard, img: overrideImg };
//   } else {
//     card = {
//       header: "RECOMMENDED POSITIONING",
//       name: "Mr/Ms. Dummy",
//       tagline: "Build trust through steady presence and risk reduction.",
//       bullets: [
//         "Maintain a steady, reliable presence",
//         "Focus on risk reduction strategies",
//         "Emphasize problem avoidance",
//         "Provide clear, consistent communication",
//       ],
//       img: dependableImg,
//       alt: "Dependable Icon",
//     };
//   }

//   // map only selected channels for the button bar
//   const selectedChannelObjs = (selectedChannels || [])
//     .map((id) => {
//       if (id === "others") {
//         return {
//           id: "others",
//           label:
//             otherChannel && otherChannel.trim() !== "" ? otherChannel : "Others",
//           icon: null,
//         };
//       }
//       return allChannels.find((ch) => ch.id === id);
//     })
//     .filter(Boolean);

//   // highlight state for button bar
//   const [selectedChannel, setSelectedChannel] = useState(
//     currentChannelId || selectedChannels[0] || ""
//   );
//   const [showTimeline, setShowTimeline] = useState(Array(4).fill(false));
//   const [showFrequency, setShowFrequency] = useState(Array(4).fill(false));

//   const handleTaskChange = (idx, val) => {
//     setTasks((prev) => prev.map((t, i) => (i === idx ? { ...t, value: val } : t)));
//   };

//   const handleTimelineChange = (idx, val) => {
//     setTasks((prev) =>
//       prev.map((t, i) => (i === idx ? { ...t, timeline: val } : t))
//     );
//     setShowTimeline((show) =>
//       show.map((open, i) => (i === idx ? false : open))
//     );
//   };

//   const handleFrequencyChange = (idx, val) => {
//     setTasks((prev) =>
//       prev.map((t, i) => (i === idx ? { ...t, frequency: val } : t))
//     );
//     setShowFrequency((show) =>
//       show.map((open, i) => (i === idx ? false : open))
//     );
//   };

//   return (
//     <div className="w-full bg-white max-h-[80vh] overflow-y-auto scrollbar-hide flex flex-col">
//       <div className="max-w-6xl w-full pb-4">
//         <div
//           className="text-[#323232] text-[16px] font-normal leading-[160%] mb-2"
//           style={{ fontFamily: "Gotham, sans-serif" }}
//         >
//           Now that you know what they seek, let's create your brand.
         
//         </div>
//       </div>
//       <div className=" w-full flex flex-row gap-4 px-8">
//         {/* LEFT: hero image + progress text */}
//         <div className="flex flex-col items-center min-w-[320px] max-w-[367px] pt-6">
//           <div
//             className="relative"
//             style={{
//               width: 268.56,
//               height: 313.44,
//               marginTop: 0,
//               marginLeft: 8,
//               borderRadius: 10,
//             }}
//           >
//             <img
//               src={narrative_image}
//               alt="Narrative Hero"
//               className="block w-full h-full object-contain"
//               style={{ borderRadius: 10 }}
//               draggable={false}
//             />
//             <img
//               src={semiFilled}
//               alt="Narrative progress"
//               className="pointer-events-none select-none"
//               style={{
//                 position: "absolute",
//                 left: 0,
//                 top: 42,
//                 width: "100%",
//                 height: "100%",
//                 objectFit: "contain",
//                 borderRadius: 10,
//               }}
//               draggable={false}
//             />
//             {/* Progress overlay */}
//             <div
//               className="absolute"
//               style={{
//                 left: -24,
//                 bottom: 24,
//                 minWidth: 0,
//                 textAlign: "left",
//               }}
//             >
//               <div className="flex flex-col">
//                 <span
//                   style={{
//                     fontFamily: "Gotham, sans-serif",
//                     fontWeight: 500,
//                     fontStyle: "normal",
//                     fontSize: 11.94,
//                     lineHeight: "135%",
//                     letterSpacing: 0,
//                     textTransform: "uppercase",
//                     color: "#454545",
//                   }}
//                 >
//                   MY NARRATIVE
//                 </span>
//                 <span
//                   style={{
//                     fontFamily: "Gotham, sans-serif",
//                     fontWeight: 500,
//                     fontStyle: "normal",
//                     fontSize: 15.92,
//                     lineHeight: "135%",
//                     letterSpacing: 0,
//                     textTransform: "uppercase",
//                     color: "#1DA4A2",
//                   }}
//                 >
//                   70% COMPLETE
//                 </span>
//               </div>
//               <div
//                 style={{
//                   width: 199.8,
//                   borderTop: "1px solid #454545",
//                   marginTop: 4,
//                 }}
//               />
//             </div>
//           </div>

//           {/* Card below the image */}
//           <RecommendedPositionCard card={card} />
//         </div>

//         <div className="flex-1 flex flex-col pt-6 pl-10 ">
//           {/* Section A */}
//           <div className="flex flex-row items-start mb-10">
//             <div
//               className="flex items-center justify-center mr-4 mt-2"
//               style={{
//                 width: 39.73,
//                 height: 39.73,
//                 borderRadius: 66.22,
//                 background: "#E6E6E6",
//                 border: "1.66px solid #CCCCCC",
//               }}
//             >
//               <span
//                 style={{
//                   color: "#444444",
//                   fontFamily: "Gotham, sans-serif",
//                   fontWeight: 400,
//                   fontSize: 22.88,
//                   lineHeight: "100%",
//                   letterSpacing: 0,
//                 }}
//               >
//                 A
//               </span>
//             </div>
//             <div className="flex-1">
//               <div
//                 className="font-bold text-[#222] text-lg mb-0"
//                 style={{ fontFamily: "Gotham, sans-serif" }}
//               >
//                 Who Am I to my Stakeholders?
//               </div>
//               <div
//                 className="text-[#949494] text-base mb-2"
//                 style={{ fontFamily: "Gotham, sans-serif" }}
//               >
//                 Eg. I am the Operations Lead who ensures we never miss a deadline, irrespective of project complexity.
//               </div>
//               <textarea
//                 rows={4}
//                 className="block w-full max-w-[653.74px] h-[166.08px] rounded-md border border-[#ADADAD] text-[#222] text-base p-3 focus:outline-none focus:border-[#13AAA4]"
//                 style={{ fontFamily: "Gotham, sans-serif" }}
//                 value={questionA}
//                 onChange={(e) => setQuestionA(e.target.value)}
//               />
//             </div>
//           </div>

//           {/* Section B */}
//           <div className="flex flex-row items-start mb-10">
//             <div
//               className="flex items-center justify-center mr-4 mt-2"
//               style={{
//                 width: 39.73,
//                 height: 39.73,
//                 borderRadius: 66.22,
//                 background: "#E6E6E6",
//                 border: "1.66px solid #CCCCCC",
//               }}
//             >
//               <span
//                 style={{
//                   color: "#444444",
//                   fontFamily: "Gotham, sans-serif",
//                   fontWeight: 400,
//                   fontSize: 22.88,
//                   lineHeight: "100%",
//                   letterSpacing: 0,
//                 }}
//               >
//                 B
//               </span>
//             </div>
//             <div className="flex-1">
//               <div
//                 className="font-bold text-[#222] text-lg mb-0"
//                 style={{ fontFamily: "Gotham, sans-serif" }}
//               >
//                 What situations can be{" "}
//                 <span className="text-[#13AAA4] font-bold">{card.name}</span> in?
//               </div>
//               <div
//                 className="text-[#949494] text-base mb-2"
//                 style={{ fontFamily: "Gotham, sans-serif" }}
//               >
//                 When last-minute data, feedback, or crisis hits and everyone is scrambling.
//               </div>
//               <textarea
//                 rows={3}
//                 className="block w-full max-w-[653.74px] h-[140.47px] rounded-md border border-[#ADADAD] text-[#222] text-base p-3 focus:outline-none focus:border-[#13AAA4]"
//                 style={{ fontFamily: "Gotham, sans-serif" }}
//                 value={questionB}
//                 onChange={(e) => setQuestionB(e.target.value)}
//               />
//             </div>
//           </div>

//           {/* Section C */}
//           <div className="my-12">
//             <div className="flex items-center mb-2">
//               <div
//                 className="flex items-center justify-center mr-4"
//                 style={{
//                   width: 39.73,
//                   height: 39.73,
//                   borderRadius: 66.22,
//                   background: "#E6E6E6",
//                   border: "1.66px solid #CCCCCC",
//                 }}
//               >
//                 <span
//                   style={{
//                     color: "#444444",
//                     fontFamily: "Gotham, sans-serif",
//                     fontWeight: 400,
//                     fontSize: 22.88,
//                     lineHeight: "100%",
//                     letterSpacing: 0,
//                   }}
//                 >
//                   C
//                 </span>
//               </div>
//               <div>
//                 <span
//                   className="font-bold text-lg"
//                   style={{ fontFamily: "Gotham, sans-serif", color: "#222" }}
//                 >
//                   3 Things I will do to become{" "}
//                   <span className="text-[#13AAA4] font-bold">{card.name}</span>
//                 </span>
//                 <div
//                   className="text-[#949494] text-base"
//                   style={{ fontFamily: "Gotham, sans-serif" }}
//                 >
//                   Eg. For Email/Slack channels: Send proactive status updates before they are asked for.
//                 </div>
//               </div>
//             </div>

//             {/* Button Bar */}
//             <div
//               className="flex flex-row ml-12 items-center justify-center mb-6"
//               style={{
//                 width: "100%",
//                 maxWidth: 700,
//                 height: 44,
//                 background: "rgba(230,230,230,0.5)",
//                 borderRadius: 4,
//                 padding: 4,
//                 gap: 10,
//               }}
//             >
//               {selectedChannelObjs.map((ch) => (
//                 <button
//                   key={ch.id}
//                   className="flex items-center justify-center mr-3 px-4"
//                   style={{
//                     height: 34,
//                     minWidth: 90,
//                     borderRadius: 3.04,
//                     background: selectedChannel === ch.id ? "#fff" : "transparent",
//                     boxShadow:
//                       selectedChannel === ch.id ? "0 1px 3px #00000010" : undefined,
//                     fontFamily: "Gotham, sans-serif",
//                     fontSize: 16,
//                     marginRight: ch.id !== "others" ? 16 : 0,
//                   }}
//                   onClick={() => {
//                     setSelectedChannel(ch.id);
//                     if (setCurrentChannelId) setCurrentChannelId(ch.id);
//                   }}
//                 >
//                   {ch.icon ? (
//                     <img
//                       src={ch.icon}
//                       alt={ch.label}
//                       style={{ width: 22, height: 22, marginRight: 6 }}
//                     />
//                   ) : (
//                     <span
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         fontSize: "26px",
//                         fontWeight: 700,
//                         marginRight: 3,
//                       }}
//                     >
//                       +
//                     </span>
//                   )}
//                   <span>{ch.label}</span>
//                 </button>
//               ))}
//             </div>

//             {/* Input Tasks */}
//             <div>
//               {tasks.map((task, idx) => (
//                 <div
//                    key={idx}
//                    style={{
//                      display: "flex",
//                      alignItems: "center",
//                      marginLeft: 30,
//                      marginBottom: 16,
//                      width: "100%",
//                      maxWidth: 700,
//                    }}
//                  >
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       borderBottom: "1.5px solid #222",
//                       height: 42,
//                       flex: 1,
//                       marginRight: 12,
//                     }}
//                   >
//                     <span
//                       style={{
//                         fontFamily: "Gotham, sans-serif",
//                         color: "#222",
//                         fontSize: 22,
//                         marginRight: 8,
//                         display: "inline-block",
//                       }}
//                     >
//                       {idx + 1}.
//                     </span>
//                     <input
//                       className="text-[#949494] text-[22px] font-normal focus:outline-none"
//                       style={{
//                         minWidth: 100,
//                         background: "transparent",
//                         height: 42,
//                         fontFamily: "Gotham, sans-serif",
//                         fontWeight: 400,
//                         border: "none",
//                         outline: "none",
//                         boxShadow: "none",
//                         color: task.value ? "#222" : "#A4A4A4",
//                         flex: 1,
//                       }}
//                       placeholder={`Action Task ${idx + 1}`}
//                       value={task.value}
//                       onChange={(e) => handleTaskChange(idx, e.target.value)}
//                     />
//                   </div>
//                   <div
//                     style={{ position: "relative", width: 124, height: 34, marginRight: 10 }}
//                   >
//                     <button
//                       type="button"
//                       className="w-full h-full flex items-center justify-between px-3 rounded border border-[#F0F0F0] bg-white"
//                       style={{
//                         borderRadius: 3.04,
//                         fontFamily: "Gotham, sans-serif",
//                         fontSize: 12,
//                         opacity: 0.8,
//                         color: "#585858",
//                       }}
//                       onClick={() =>
//                         setShowTimeline((show) =>
//                           show.map((open, i) => (i === idx ? !open : false))
//                         )
//                       }
//                     >
//                       {task.timeline || "Timeline"}
//                       <svg
//                         width="8"
//                         height="4"
//                         viewBox="0 0 14 8"
//                         fill="none"
//                         style={{ marginLeft: 6, marginRight: -6 }}
//                       >
//                         <path
//                           d="M1 1.5L7 7.5L13 1.5"
//                           stroke="#C1C1C1"
//                           strokeWidth="1.2"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                         />
//                       </svg>
//                     </button>
//                     {showTimeline[idx] && (
//                       <div
//                         className="absolute z-10 w-full top-full left-0 bg-white border border-[#ADADAD] rounded"
//                         style={{
//                           fontFamily: "Gotham, sans-serif",
//                           fontSize: 12,
//                           marginTop: 3,
//                         }}
//                       >
//                         {TIMELINE_OPTIONS.map((opt) => (
//                           <div
//                             key={opt}
//                             className="px-3 py-2 cursor-pointer hover:bg-[#E6E6E6]"
//                             style={{ borderRadius: 2.2, color: "#222" }}
//                             onClick={() => handleTimelineChange(idx, opt)}
//                           >
//                             {opt}
//                           </div>
//                         ))}
//                       </div>
//                     )}
//                   </div>
//                   <div style={{ position: "relative", width: 124, height: 34 }}>
//                     <button
//                       type="button"
//                       className="w-full h-full flex items-center justify-between px-3 rounded border border-[#F0F0F0] bg-white"
//                       style={{
//                         borderRadius: 3.04,
//                         fontFamily: "Gotham, sans-serif",
//                         fontSize: 12,
//                         opacity: 0.8,
//                         color: "#585858",
//                       }}
//                       onClick={() =>
//                         setShowFrequency((show) =>
//                           show.map((open, i) => (i === idx ? !open : false))
//                         )
//                       }
//                     >
//                       {task.frequency || "Frequency"}
//                       <svg
//                         width="8"
//                         height="4"
//                         viewBox="0 0 14 8"
//                         fill="none"
//                         style={{ marginLeft: 6, marginRight: -6 }}
//                       >
//                         <path
//                           d="M1 1.5L7 7.5L13 1.5"
//                           stroke="#C1C1C1"
//                           strokeWidth="1.2"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                         />
//                       </svg>
//                     </button>
//                     {showFrequency[idx] && (
//                       <div
//                         className="absolute z-10 w-full top-full left-0 bg-white border border-[#ADADAD] rounded"
//                         style={{
//                           fontFamily: "Gotham, sans-serif",
//                           fontSize: 12,
//                           marginTop: 3,
//                           color: "#585858",
//                         }}
//                       >
//                         {FREQUENCY_OPTIONS.map((opt) => (
//                           <div
//                             key={opt}
//                             className="px-3 py-2 cursor-pointer hover:bg-[#E6E6E6]"
//                             style={{ borderRadius: 2.2, color: "#222" }}
//                             onClick={() => handleFrequencyChange(idx, opt)}
//                           >
//                             {opt}
//                           </div>
//                         ))}
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               ))}
//             </div>

//             <div className="mt-12 flex">
//               <button
//                 className="bg-black text-white text-lg font-medium rounded-[16.2px] ml-12 px-8 py-4 flex items-center"
//                 style={{
//                   width: 231,
//                   height: 56,
//                   justifyContent: "space-between",
//                   fontFamily: "Gotham, sans-serif",
//                   paddingTop: 17.8,
//                   paddingBottom: 17.8,
//                   paddingLeft: 16.2,
//                   paddingRight: 16.2,
//                   borderRadius: 16.2,
//                 }}
//                 onClick={() => onNextStep()}
//               >
//                 Go to Next Step
//                 <span
//                   className="ml-2"
//                   style={{ display: "flex", alignItems: "center", fontSize: 20 }}
//                 >
//                   <svg width={22} height={22} viewBox="0 0 22 22" fill="none">
//                     <circle cx="11" cy="11" r="11" fill="#fff" />
//                     <path
//                       d="M9 7l4 4-4 4"
//                       stroke="#151A1F"
//                       strokeWidth="2"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                     />
//                   </svg>
//                 </span>
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }